export const getFixedPlaces = (value: number) => {
	return value % 1 != 0 ? value.toString().split(".")[1].length : 0;
};
